import _extends from 'babel-runtime/helpers/extends';

import { mapGetters } from 'vuex';
import { Navbar, Sidebar, AppMain } from './components';

export default {
  name: 'BiLayout',
  components: {
    Navbar: Navbar,
    Sidebar: Sidebar,
    AppMain: AppMain
  },
  data: function data() {
    return {};
  },

  computed: _extends({}, mapGetters(['biRouters'])),
  methods: {
    navClick: function navClick(index) {}
  }
};